import type { FaireProductEntity } from "../../entity_types/product";

export const p_nv4wg45nz4: FaireProductEntity = {
  token: "p_nv4wg45nz4",
  type: "product",
  name: "Cute Flowers",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/0bde98eb03ae6279949619769859e69c8bc90bc60461bb07595d5de7e2d131fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ad6daee4566c5e4d58f3f90277623e6eda0e895c0ec1814d3df91931efbfca44.jpeg",
    "https://cdn.faire.com/fastly/bae3e12cceec31bbcc1be9db694656bdefd96a6ed1a465aae089e781c59788ed.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:55.121Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
